import React, { Fragment } from 'react';

const InsuranceConverage = ({ city = 'toronto' }) => (
  <Fragment>
    <ol>
      <li>
        <strong>Online insurance</strong>
        <ul>
          <li>
            Covers you while you are online on a rideshare driver
            application app.
          </li>
          <li>
            Covered by the rideshare company's insurance policy (i.e Uber).
          </li>
          <li>
            Pink insurance slip can be found within the rideshare driver
            application (i.e Uber Driver app).
          </li>
          <li>
            Maintains a $2,500 insurance deductible unless you opt for
            Autzu’s reduced deductible plan to lower your deductible to
            $1,000.
          </li>
        </ul>
      </li>
      <li>
        <strong>Offline insurance</strong>
        <ul>
          <li>
            Covers you when you are offline on a rideshare driver app, such
            as taking breaks, recharging at Supercharger stations, and
            driving in and out of the Autzu parking lot. Covered by Autzu’s
            insurance policy
            <li>
              Pink insurance slip can be found inside the Autzu app during
              a reservation. From your dashboard, scroll to the quick links
              and choose "Insurance slip" to access the insurance section.
              Click on "No, I was offline" to obtain Autzu's insurance
              details.
            </li>
            <li>
              Maintains a $2,500 deductible unless you opt for Autzu’s
              reduced deductible plan to lower your deductible to $1,000.
            </li>
          </li>
        </ul>
      </li>
    </ol>
    <div>
      <strong>Specific insurance coverages:</strong>
      <ul>
        <li>
          $2 million of Liability
          <ul style={{ listStyleType: 'circle' }}>
            <li>
              $2 million coverage when at-fault or liable to pay for
              property damages or third-party injury.
            </li>
          </ul>
        </li>
        <li>
          Statutory Ontario accident benefits
          <ul style={{ listStyleType: 'circle' }}>
            <li>
              $2 million of Uninsured Automobile Coverage Protects vehicle
              occupants who are injured by a hit-and-run driver, an
              uninsured motorist, or an inadequately insured motorist. It
              also covers damage to your vehicle caused by an identified
              uninsured driver.
            </li>
          </ul>
        </li>
        <li>
          Direct Compensation – Property Damage Coverage
          <ul style={{ listStyleType: 'circle' }}>
            <li>
              This statutory coverage pays for repairs to a driver’s
              vehicle, as well as related expenses, in the event of an
              accident that is not entirely the driver’s fault.
            </li>
          </ul>
        </li>
        <li>
          Contingent Collision and Comprehensive
          <ul style={{ listStyleType: 'circle' }}>
            <li>
              This covers loss or physical damage to the driver’s vehicle
              up to the actual cash value of the vehicle subject to a
              deductible of either $2,500, or $1,000 if you choose to opt
              into Autzu’s reduced insurance deductible plan.
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <p>
      If you are deemed not-at-fault, you will not have to pay any
      insurance deductible.
    </p>
  </Fragment>
);

export default InsuranceConverage;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/AccidentsAndInsurance/InsuranceCoverage.js